<app-banner></app-banner>

<section class="main-section register white-bg">
    <div class="width-container">
        <h2 [innerHtml]="'REGISTER.HEAD' | translate:data"></h2>
        <p [innerHtml]="'REGISTER.DESC' | translate:data"></p>
        <h3 [innerHtml]="'REGISTER.SUBHEAD' | translate:data"></h3>
        <app-form></app-form>
        <p class="small-text" [innerHtml]="'REGISTER.FOOTNOTE' | translate:data"></p>
    </div>
</section>